import { useAuth0 } from '@auth0/auth0-react';
import { Outlet } from '@tanstack/react-router';

import LoadingScreen from '@/components/LoadingScreen';
import LoginScreen from '@/components/LoginScreen';
import { usePermissions } from '@/hooks/usePermissions';

export default function AuthenticatedApp() {
  const { isLoading, isAuthenticated, error } = useAuth0();
  const { isAdmin, loading: permissionsLoading } = usePermissions();

  // Handle Auth0 errors
  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center max-w-md mx-auto p-6">
          <h1 className="text-2xl font-bold text-destructive mb-4">
            Authentication Error
          </h1>
          <p className="text-muted-foreground mb-4">{error.message}</p>
          <button
            onClick={() => window.location.reload()}
            className="bg-primary text-primary-foreground px-4 py-2 rounded-md hover:bg-primary/90"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  if (isLoading || permissionsLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <LoginScreen />;
  }

  // Check if user has admin permissions
  if (!isAdmin()) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-destructive mb-4">
            Access Denied
          </h1>
          <p className="text-muted-foreground mb-4">
            You do not have admin privileges to access this dashboard.
          </p>
          <p className="text-sm text-muted-foreground">
            Contact your administrator to request admin access.
          </p>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
